export enum CandidateEducation {
    HighSchool = 'high-school',// 'תיכונית',
    AfterHighSchool = 'after-high-school',// 'על תיכונית',
    TeachingCertificate = 'teaching-certificate',// 'תעודת הוראה',
    FirstDegree = 'first-degree',// 'תואר ראשון',
    SecondDegree = 'second-degree',// 'תואר שני',
    ThirdDegree = 'third-degree',// 'תואר שלישי',
}